import React from 'react';

/**
 * Rota `/healthcheck`.
 *
 * Mantida porque o monitoramento externo já aponta para ela. A resposta
 * precisa continuar sendo exatamente o texto `Teste OK`.
 */
export function Healthcheck() {
  return <pre style={{ fontFamily: 'monospace', margin: 16 }}>Teste OK</pre>;
}
